import React from 'react'

export const Drafts = (color = '#1973B8', width = 28, height = 27) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9993 0.333008L26.066 7.53301C26.466 7.77745 26.7771 8.11079 26.9993 8.53301C27.2216 8.95523 27.3327 9.39967 27.3327 9.86634V24.333C27.3327 25.0663 27.0716 25.6941 26.5493 26.2163C26.0271 26.7386 25.3993 26.9997 24.666 26.9997H3.33268C2.59935 26.9997 1.97157 26.7386 1.44935 26.2163C0.927127 25.6941 0.666016 25.0663 0.666016 24.333V9.86634C0.666016 9.39967 0.777127 8.95523 0.999349 8.53301C1.22157 8.11079 1.53268 7.77745 1.93268 7.53301L13.9993 0.333008ZM13.9993 15.8663L24.3993 9.66634L13.9993 3.46634L3.59935 9.66634L13.9993 15.8663ZM13.9993 18.9997L3.33268 12.5997V24.333H24.666V12.5997L13.9993 18.9997Z"
        fill={color}
      />
    </svg>
  )
}
